import Reflux from "reflux";
import { qualifyUrl } from "util/URLUtils";
import { fetchPeriodically } from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
import { singletonStore, singletonActions } from "logic/singleton";
import Session from "logic/session/Session";
export const NodesActions = singletonActions(
  "core.Nodes",
  () => Reflux.createActions({
    list: { asyncResult: true }
  })
);
export const NodesStore = singletonStore(
  "core.Nodes",
  () => Reflux.createStore({
    listenables: [NodesActions],
    nodes: void 0,
    clusterId: void 0,
    nodeCount: 0,
    INTERVAL: 5e3,
    // 5 seconds
    promises: {},
    init() {
      if (this.nodes === void 0) {
        this._triggerList();
        setInterval(this._triggerList, this.INTERVAL);
      }
    },
    _triggerList() {
      if (Session.isLoggedIn()) {
        NodesActions.list();
      }
    },
    getInitialState() {
      return this.getNodesInfo();
    },
    getNodesInfo() {
      return { nodes: this.nodes, clusterId: this.clusterId, nodeCount: this.nodeCount };
    },
    list() {
      const promise = this.promises.list || fetchPeriodically("GET", qualifyUrl(ApiRoutes.ClusterApiResource.list().url)).then((response) => {
        this.nodes = {};
        if (response.nodes) {
          this.nodes = Object.fromEntries(response.nodes.map((node) => [node.node_id, node]));
          this.clusterId = this._clusterId();
          this.nodeCount = this._nodeCount();
          this._propagateState();
        }
        return response;
      }).finally(() => delete this.promises.list);
      this.promises.list = promise;
      NodesActions.list.promise(promise);
    },
    getNode(nodeId) {
      var _a;
      return (_a = this.nodes) == null ? void 0 : _a[nodeId];
    },
    _clusterId() {
      const nodeInCluster = Object.keys(this.nodes).map((id) => this.nodes[id]).find((node) => node.cluster_id);
      return nodeInCluster ? nodeInCluster.cluster_id.toUpperCase() : void 0;
    },
    _nodeCount() {
      return Object.keys(this.nodes).length;
    },
    _propagateState() {
      this.trigger(this.getNodesInfo());
    }
  })
);
